import i18next from "i18next";
import React from "react";
import { useMapContext } from "../../Contexts/MapContext";
import { useMapDownloadContext } from "../../Contexts/MapDownloadContext";
import { WidgetToolbar } from "../Widget/WidgetToolbar";
import { SheetDownload } from "./SheetDownload";
import { SheetSearch } from "./SheetSearch";
import { MapSelect } from "./MapSelect";
import { PolygonSelect } from "./PolygonSelect";
import { SelectedSheets } from "./SelectedSheets";
import "./SheetSelector.scss";

export const SheetSelector = (): JSX.Element => {
    return (
        <div className="sheet-selector">
            <WidgetToolbar className={"sheet-select-toolbar"}>
                <MapSelect />
                <PolygonSelect />
            </WidgetToolbar>
            <ErrorMessage />
            <SheetSearch />
            <SelectedSheets />
            <SheetDownload />
        </div>
    );
};

const ErrorMessage = () => {
    const { configA } = useMapContext();
    const { limitExceeded } = useMapDownloadContext();

    return (
        <>
            {limitExceeded && (
                <div className="selector-error">
                    <div className="info-text">
                        {i18next
                            .t("mapDownload.numberOfMapDownloadsTooLarge")
                            .replace("'{0}'", configA.geotelpa.mapDownloadMaxCount.toString())}
                    </div>
                </div>
            )}
        </>
    );
};
